import { ApolloClient, InMemoryCache } from '@apollo/client/core'
import { provideApolloClient, useQuery} from "@vue/apollo-composable";
import CONCORD_QUERIES from "./concord_queries.js"
import {
    watch
  } from 'vue'
export default {
    setupApollo() {
        if (!window.walkuere_app_data || !window.walkuere_app_data.concord_url) {
            return false;
        }
        const cache = new InMemoryCache();
        const customHeaders = {
          platform: 'web', // Add your custom header(s) here
          'App-Version': '1.10.290',
          App: window.walkuere_app_name ? window.walkuere_app_name : 'entwickler',
        };
        const apolloClient = new ApolloClient({
            cache,
            uri: window.walkuere_app_data.concord_url,
            headers: customHeaders,
          })
        provideApolloClient(apolloClient)
        return true;
    },
    getSpeakers:function (seriesid,conferenceUniqueId, pageSizeAttr,pageAttr,speakerQualifications,brandId,trackFilter){
        if (!this.setupApollo()) {
            return {
                result:null,
                loading:false, 
                error:true
              }
        }
        let variablesForQier = {
            conferenceSeriesId:seriesid,
            instanceId: conferenceUniqueId,
            pagesize:pageSizeAttr,
            page:pageAttr,
            qualificationIdIn:speakerQualifications,
            brandId:brandId,
            trackFilter:trackFilter,
        };
        return useQuery(CONCORD_QUERIES.SPEAKER_QUERY(variablesForQier), variablesForQier);
    },
    getSpeakersBrandId:function (pageSizeAttr,pageAttr,brandsid){
        console.log('gettttt');
        if (!this.setupApollo()) {
            return {
                result:null,
                loading:false, 
                error:true
              }
        }
        let variablesForQier = {
            pagesize:pageSizeAttr,
            page:pageAttr,
            conferenceBrandId: brandsid,
        };
        return useQuery(CONCORD_QUERIES.SPEAKER_QUERY_BY_BRAND_ID, variablesForQier);
    },
    getSpeakersForBlog(slugs){
        if (!this.setupApollo()) {
            return {
                result:null,
                loading:false, 
                error:true
              }
        }
        let variablesForQier = {
            slugs:slugs
        };
        
        return useQuery(CONCORD_QUERIES.EXPERTS_BY_SLUG_QUERY,variablesForQier);
    },
    getSalesSponsors:function (seriesid){
        if (!this.setupApollo()) {
            return {
                result:null,
                loading:false, 
                error:true
              }
        }
        let variablesForQier = {
            conferenceSeriesId:seriesid
        };
        return useQuery(CONCORD_QUERIES.SALES_SPONSOR_QUERY, variablesForQier);
    },
    getMarketingSponsors:function (seriesid){
        if (!this.setupApollo()) {
            return {
                result:null,
                loading:false, 
                error:true
              }
        }
        let variablesForQier = {
            conferenceSeriesId:seriesid
        };
        return useQuery(CONCORD_QUERIES.MARKETING_SPONSOR_QUERY, variablesForQier);
    },
    getSessions:function (queryVariables){
        if (!this.setupApollo()) {
            return {
                result:null,
                loading:false, 
                error:true
              }
        }
        return useQuery(CONCORD_QUERIES.SESSIONS_QUERY(queryVariables), queryVariables);
    },
    getSessionsBySlug:function (sessionSlug,brandId){
        if (!this.setupApollo()) {
            return {
                result:null,
                loading:false, 
                error:true
              }
        }
        let variablesForQier = {
            sessionSlug:sessionSlug,
            brandId:brandId
        };
        return useQuery(CONCORD_QUERIES.SESSION_BY_SLUG_QUERY, variablesForQier);
    },
    getSessionsByTrack:function (id,conferenceId){
        if (!this.setupApollo()) {
            return {
                result:null,
                loading:false, 
                error:true
              }
        }
        let variablesForQier = {
            id:id,
            conferenceId:conferenceId
        };
        return useQuery(CONCORD_QUERIES.SESSION_BY_TRACK_QUERY, variablesForQier);
    },
    getProgramForTrackPage:function (id,trackIn,pageAttr, pageSizeAttr){
        if (!this.setupApollo()) {
            return {
                result:null,
                loading:false, 
                error:true
              }
        }
        let queryVariables = {
            id:id,
            trackIn:trackIn,
            page:pageAttr, 
            pagesize:pageSizeAttr
        };
        return useQuery(CONCORD_QUERIES.PROGRAM_FOR_TRACK_PAGE_QUERY, queryVariables);
    },
    getSpecialDays:function (conferenceBrandId,id){
        if (!this.setupApollo()) {
            return {
                result:null,
                loading:false, 
                error:true
              }
        }
        let variablesForQier = {
            conferenceBrandId:conferenceBrandId,
            conferenceSeriesId:id
        };
        return useQuery(CONCORD_QUERIES.SPECIAL_DAYS_QUERY, variablesForQier);
    },
    getSpecialDaysDetails:function (specialDayIds_in,conferenceBrandId){
        if (!this.setupApollo()) {
            return {
                result:null,
                loading:false, 
                error:true
              }
        }
        let variablesForQier = {
            specialDayIds_in:specialDayIds_in,
            conferenceBrandId:conferenceBrandId,
        };
        return useQuery(CONCORD_QUERIES.SPECIAL_DAYS_DETAILS_QUERY, variablesForQier);
    },
    getSpecialDaysDisplay:function (conferenceBrandId){
        if (!this.setupApollo()) {
            return {
                result:null,
                loading:false, 
                error:true
              }
        }
        let variablesForQier = {
            conferenceBrandId:conferenceBrandId
        };
        return useQuery(CONCORD_QUERIES.SPECIAL_DAYS_DISPLAY_QUERY, variablesForQier);
    },

    getBrandData(brandSlug){
        if (!this.setupApollo()) {
          return {
            result:null,
            loading:false, 
            error:true
          }
        }
        let variablesForQier = {
          slug:brandSlug,
        };
        return useQuery(CONCORD_QUERIES.GET_BRAND_HERO, variablesForQier);
    
      },
      getPocDataForBrands(slug,type,page,pageSize){
        return new Promise((resolve, reject) => {
          if (!this.setupApollo()) {
            return {
              result:null,
              loading:false, 
              error:true
            }
          }
          let variablesForQier = {
            type: type,
            brandComplexSlug:slug,
            PAGE:page,
            PAGE_SIZE:pageSize,
          };
          const {
            result } =  useQuery(CONCORD_QUERIES.GET_BRAND_POC_ISSUE, variablesForQier);
            watch(result, value => {
              if (value) {
                resolve(value);
              }else{
                reject('Error fetching data');
              }
            });
        });
    
      },


      getCorrectPocType(parentGenre, parentSchemaType, pocSchemaType) {
        switch (parentGenre) {
          case 'TUTORIAL':
            return 'Tutorial';
          
          case 'FSLE':
            return 'Live Event';
      
          case 'COURSE':
            if (window && window['sands_reader_app_context']) {
              const sands_reader_app_context = window['sands_reader_app_context'];
              if (sands_reader_app_context.small_app_version) {
                return 'Course';
              }
            }
            return 'Course';
      
          case 'RHEINGOLD':
            return 'Conference';
      
          case 'FLEX_CAMP':
            return 'Flex Camp';
      
          case 'CAMP':
            return 'Camp';
      
          default:
            // Handle other cases not explicitly mentioned
            if (parentGenre === 'COURSE' && parentSchemaType === 'COURSE') {
              return 'Lesson';
            }
            if (pocSchemaType) {
              return pocSchemaType.toString();
            }
            return '';
        }
      }
  }
  
  